module.exports = __webpack_public_path__ + "static/LucasPope2-a77e10286311ad7e1bb25a2ad797bac4.png";